import { render, staticRenderFns } from "./PrintAttention.vue?vue&type=template&id=e83b7a18&scoped=true"
import script from "./PrintAttention.vue?vue&type=script&lang=js"
export * from "./PrintAttention.vue?vue&type=script&lang=js"
import style0 from "./PrintAttention.vue?vue&type=style&index=0&id=e83b7a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e83b7a18",
  null
  
)

export default component.exports